  import React from 'react';
import { NavigationContainer } from '@react-navigation/native';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { createStackNavigator } from '@react-navigation/stack';
import { navigationRef } from './root.navigation.js';
import { Badge } from './badge/badge.js'
import { BottomNavigation, BottomNavigationTab, Layout, Text, Icon } from '@ui-kitten/components';
import { View } from 'react-native';
import {HomeScreen} from './src/screens/home-screen'
import {ProfileScreen} from './src/screens/profile-screen'
import {AddressScreen} from './src/screens/newAddress-screen'
import {NewAddressList} from './src/screens/newAddress-list-screen'
import {Prices} from './src/screens/newAddress-list-screen/prices.js'
import {LoginScreen} from './src/screens/login-screen'
import {ChatScreen} from './src/screens/support-screen/chat'
import {SupportScreen} from './src/screens/support-screen'
import {RegisterForm} from './src/screens/register-screen/register-form'
import {RegisterScreen} from './src/screens/register-screen'
import {UploadPictures} from './src/screens/register-screen/register-form/upload.js'
import {DoingScreen} from './src/screens/Doing-tasks-screen'
import {Canceling} from './src/screens/Doing-tasks-screen/newcancel.js'
import {QrScreen} from './src/screens/Doing-tasks-screen/qr.screen.js'
// import {EditProfile} from './src/screens/edit-profile-screen'
import {EditProfile} from './src/screens/edit-profile-screen/index.web.js'
import {SingleNewsScreen} from './src/screens/news-screen/singleNews.js'
import {NewsScreen} from './src/screens/news-screen'
import {CompleteScreen} from './src/screens/Doing-tasks-screen/completeTask/index.web.js'
// import {CompleteScreen} from './src/screens/Doing-tasks-screen/completeTask/index.js'
import {NewReqScreen} from './src/screens/support-screen/new-request'
import {CompletedTasks} from './src/screens/completed-tasks-screen'
import {AddressHistory} from './src/screens/Address-History'
import {PaymentList} from './src/screens/payment-list-screen'
import {SupervisorScreen} from './src/screens/supervisor-screen'
import {SubsetTask} from './src/screens/supervisor-screen/tasks'
import {SubsetProfile} from './src/screens/supervisor-screen/profile'
import {AddSupervisorScreen} from './src/screens/supervisor-screen/add'
import {FinishedTask} from './src/screens/completed-tasks-screen/single'
import {OpenTasks} from './src/screens/open-tasks-screen'
import {Faq} from './src/screens/faq-screen'
import {Sharayet} from './src/screens/faq-screen/sharayet.js'
import trackerApi from './src/api/tracker';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useIsFocused } from "@react-navigation/native";


const { Navigator, Screen } = createBottomTabNavigator();
const Stack = createStackNavigator();

const PersonIcon = (props) => (
  <Icon {...props} name='person'/>
);


const MessageIcon = (props) => (
  <Icon {...props} name='message-square'/>
);

const AddIcon = (props) => (
  <Icon {...props} name='file-add'/>
);
const HomeIcon = (props) => (
  <Icon {...props} name='grid'/>
);


const BottomTabBar = ({ navigation, state }) => {
  const [homeNotif, setHomeNotif] = React.useState(0)
  const [supportNotif, setSupportNotif] = React.useState(0)
  const isVisible = useIsFocused();

  const getNotifs = async ()=>{
    const token =  await AsyncStorage.getItem('userId');
    const response = await trackerApi.post('/invoice/agent_dashboard',null, {
      headers: {Authorization: `Bearer ${token}`}
    });
    if(response.data.status) setHomeNotif(response.data.newTask)
    else console.log(response.data);
    // setData(response.data.allData);

    const response2 = await trackerApi.post('/support/agent_support_notifs',null, {
      headers: {Authorization: `Bearer ${token}`}
    });
    console.log(response2.data)
    if(response2.data.status) setSupportNotif(response2.data.count)
    else console.log(response2.data);
  }

  React.useEffect(()=>{
    getNotifs()
  },[isVisible])
  return(
  <BottomNavigation
  tabBarVisible={false}
    selectedIndex={state.index}
    style={{paddingBottom:5}}
    onSelect={index => navigation.navigate(state.routeNames[index])}>
    <BottomNavigationTab title='خانه' icon={(props) => (
          <View>
    <Icon {...props} name='grid'/>
    { homeNotif ?
     <View
          style={{
            height: 15,
            width: 15,
            backgroundColor: "red",
            borderRadius: 10,
            position: "absolute",
            left: 15,
          }}
        >
          <Text
            style={{ color: "#fff", textAlign: "center", fontSize: 10 }}
          >
            {homeNotif}
          </Text>
        </View> : null
      }
      </View>
    )}/>
    <BottomNavigationTab title='ثبت آدرس' icon={AddIcon}/>
    <BottomNavigationTab title='پشتیبانی' icon={(props) => (
          <View>
    <Icon {...props} name='message-square'/>
    { supportNotif ?
     <View
          style={{
            height: 15,
            width: 15,
            backgroundColor: "red",
            borderRadius: 10,
            position: "absolute",
            left: 15,
          }}
        >
          <Text
            style={{ color: "#fff", textAlign: "center", fontSize: 10 }}
          >
            {supportNotif}
          </Text>
        </View> : null
      }
      </View>
    )}/>
    <BottomNavigationTab title='پروفایل' icon={PersonIcon}/>
  </BottomNavigation>
);}

const TabNavigator = () => {
return(
  <Navigator screenOptions={{ headerShown: false }} tabBar={props => <BottomTabBar {...props} />}>
    <Screen name='home' component={HomeScreen} />
    <Screen name='invoice' component={NewAddressList}/>
    <Screen name='support' component={SupportScreen} />
    <Screen name='profile' component={ProfileScreen}/>
  </Navigator>
);
}

export const AppNavigator = () => {

  return(
  <NavigationContainer ref={navigationRef}>
    <Stack.Navigator initialRouteName="Login" screenOptions={{headerShown: false, initialRouteName:'Home' }}>
      <Stack.Screen name="Login" component={LoginScreen} />
      <Stack.Screen name="Register" component={RegisterScreen} />
      <Stack.Screen name="RegisterForm" component={RegisterForm} />
      <Stack.Screen name="Menu" component={TabNavigator}  />
      <Stack.Screen name="Chat" component={ChatScreen} />
      <Stack.Screen name="Upload" component={UploadPictures} />
      <Stack.Screen name="EditProfile" component={EditProfile} />
      <Stack.Screen name="Doing" component={DoingScreen} />
      <Stack.Screen name="SingleNews" component={SingleNewsScreen} />
      <Stack.Screen name="CompleteTask" component={CompleteScreen} />
      <Stack.Screen name="NewRequest" component={NewReqScreen} />
      <Stack.Screen name="News" component={NewsScreen} />
      <Stack.Screen name="NewAddress" component={AddressScreen} />
      <Stack.Screen name="CompletedTasks" component={CompletedTasks} />
      <Stack.Screen name="FinishedTask" component={FinishedTask} />
      <Stack.Screen name="AddressHistory" component={AddressHistory} />
      <Stack.Screen name="OpenTasks" component={OpenTasks} />
      <Stack.Screen name="PaymentList" component={PaymentList} />
      <Stack.Screen name="Supervisor" component={SupervisorScreen} />
      <Stack.Screen name="SubsetTask" component={SubsetTask} />
      <Stack.Screen name="SubsetProfile" component={SubsetProfile} />
      <Stack.Screen name="AddSupervisor" component={AddSupervisorScreen} />
      <Stack.Screen name="Prices" component={Prices} />
      <Stack.Screen name="canceling" component={Canceling} />
      <Stack.Screen name="Faq" component={Faq} />
      <Stack.Screen name="Sharayet" component={Sharayet} />
      <Stack.Screen name="QrReader" component={QrScreen} />
    </Stack.Navigator>
  </NavigationContainer>
);
}
//
// export const AppNavigator = () => (
//   <NavigationContainer>
//     <TabNavigator/>
//   </NavigationContainer>
// );
